import React from "react";
import styled from "styled-components"; //eslint-disable-line
import tw from "twin.macro";
import {ReactComponent as SvgDecoratorBlob1} from "images/svg-decorator-blob-9.svg";
import {Container, ContentWithPaddingXl} from "components/misc/Layouts";
import {PrimaryButton as PrimaryButtonBase} from "../misc/Buttons";
import {SectionHeading} from "../misc/Headings";


const Heading = tw(SectionHeading)`w-full`;
const HighlightedText = tw.span`text-primary-500`;

const PrimaryBackgroundContainer = tw.div`py-20 lg:py-24 bg-secondary-600 rounded-lg relative`
const Row = tw.div`px-8 mx-auto flex items-center relative z-10 flex-col lg:flex-row text-center`;

const ColumnContainer = tw.div`lg:w-full mx-auto`
const TextContainer = tw(ColumnContainer)``;
const Description = tw.p`mb-6 max-w-lg mx-auto text-center text-sm md:text-base lg:text-lg font-normal leading-relaxed text-white`;

const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`
const DecoratorBlob1 = tw(SvgDecoratorBlob1)`absolute bottom-0 left-0 w-80 h-80 transform -translate-x-20 translate-y-32 text-secondary-700 opacity-50`
const DecoratorBlob2 = tw(SvgDecoratorBlob1)`absolute top-0 right-0 w-80 h-80 transform  translate-x-20 -translate-y-64 text-secondary-700 opacity-50`

const PrimaryButton = styled(PrimaryButtonBase)(props => [
    tw`mt-8 md:mt-8 text-sm inline-block mx-auto md:mx-0`,
    props.buttonRounded && tw`rounded-full`
]);

export default ({
  pushDownFooter = true,
                    onClick
}) => {
  return (
    <Container css={pushDownFooter && tw`mt-20 lg:mt-24`}>
      <ContentWithPaddingXl style={{ paddingTop: 0 }}>
          <Heading>
              Start my {" "}
              <HighlightedText>Motion Scan now</HighlightedText>
          </Heading>
          <Description style={{ textAlign: "center", color: "#131E47" }}>
              Feel the difference in how you move and live, starting now. You don’t need to travel or book time off.
          </Description>
      <PrimaryBackgroundContainer>
        <Row>
          <TextContainer>
              <Description>
                With the MAI Motion app, you can complete your full body scan from home—just by recording simple videos on your phone.
            </Description>
                <Description>
                It’s quick. It’s accurate. And it could change how you move and feel—starting today.
                </Description>
              <Description>
                Sign up now to get your access link, scan instructions, and personalised motion report.
              </Description>
              <Description>
                No gear. No guesswork. Just real answers, in your hands.
            </Description>
              <Description>
                  Decode your movement.
            </Description>
              <PrimaryButton buttonRounded onClick={onClick ? onClick : () => window.open("https://app.maimotion.com", "_blank")}>
                  SCAN NOW FOR FREE
              </PrimaryButton>
          </TextContainer>
        </Row>
        <DecoratorBlobContainer>
          <DecoratorBlob1/>
          <DecoratorBlob2/>
        </DecoratorBlobContainer>
      </PrimaryBackgroundContainer>
      </ContentWithPaddingXl>
    </Container>
  );
};
